// extracted by mini-css-extract-plugin
export default {"container":"fab_container__C22zc","icon":"fab_icon__1qxNn"};